import { useEffect, useState } from "react";
import PageTitle from "../../../module/pageTitle";
import AdminTable from "../../../Component/adminTable";
import LabelInput from "../../../Component/labelInput";
import { InputField, Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import {
  deleteCouponCode,
  getCategoryList,
  getCouponCodeById,
  getCouponCodeList,
  getProductList,
  getProductTypeList,
  updateCouponCode,
  getCouponType,
} from "../adminSlice";
import { couponTypeList } from "../../../Utils/dataConstant";
import { isValidDiscount, validateDecimal } from "../../../Utils/validators";
import { discountValue, isValidDiscountErrMsg } from "../../../Utils/errorMsg";
import DateTimePicker from "../../../Component/dateTimePicker";
import moment from "moment";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";

const EditDeleteCouponCode = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isEditMode, setisEditMode] = useState<Boolean>(false);
  const [categoryList, setCategoryList] = useState<any>([]);
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  const [category, setCategory] = useState<any>("");
  const [couponTypeList, setCouponTypeList] = useState<any>([]);
  const [couponCodeList, setCouponCodeList] = useState<any>([]);
  const [couponName, setCouponName] = useState<any>("");
  const [couponType, setCouponType] = useState<any>("");
  const [discPer, setDiscPer] = useState<any>("");
  const [productList, setProductList] = useState<any>([]);
  const [product, setProduct] = useState<any>("");
  const [couponId, setCouponId] = useState<any>("");
  const [couponData, setCouponData] = useState<any>("");
  const [startDate, setStartDate] = useState<any>(
    moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss")
  );
  const [endDate, setEndDate] = useState<any>(
    moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss")
  );
  useEffect(() => {
    getdata();
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
        },
        errorCallback: () => { },
      })
    );
    dispatch(
      getCouponType({
        callback: (res: any) => {
          setCouponTypeList(res?.data);
        },
        errorCallback: () => { },
      })
    );
  }, []);

  const getdata = () => {
    dispatch(
      getCouponCodeList({
        callback: (res: any) => {
          setCouponCodeList(res?.data);
        },
        errorCallback: () => { },
      })
    );
  };
  const onchangeCategory = (value: any) => {
    setCategory(value);
    const postData = {
      productTypeId: productType?._id,
      categoryId: value?._id,
    };
    dispatch(
      getProductList({
        params: postData,
        callback: (res: any) => {
          setProductList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
  };
  const onchangeProduct = (value: any) => {
    setProduct(value);
  };

  const onchangeCouponCode = (value: any) => {
    setCouponName(value);
  };

  const onchangeCouponType = (value: any) => {
    setCouponType(value);
  };

  const onchangeDiscPer = (value: any) => {
    if (!isValidDiscount(value)) {
      return;
    }
    if (!validateDecimal(value)) {
      return;
    }
    if (value > 100) {
      return;
    }
    setDiscPer(value);
  };
  const onchangeStartDate = (value: any) => {
    setStartDate(value);
  };
  const onchangeEndDate = (value: any) => {
    setEndDate(value);
  };
  const onchangeProductType = (value: any) => {
    setProductType(value);
    const postData = {
      productTypeId: value?._id,
    };
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
  };

  const handleEdit = (value: any) => {
    setisEditMode(true);
    setCouponId(value?._id);
    dispatch(
      getCouponCodeById({
        id: value?._id,
        callback: (res: any) => {
          setCouponData(res?.data);
          setCouponName(res?.data?.name);

          let tempCouponType = couponTypeList?.filter(
            (item: any) => res?.data?.couponType === item?.name
          );
          setCouponType(tempCouponType[0]);
          setDiscPer(res?.data?.discPer);
          dispatch(
            getProductTypeList({
              callback: (resp: any) => {
                setProductTypeList(resp?.data);
                let tempProductType = resp?.data?.find(
                  (item: any) =>
                    res?.data?.productType?._id === item?._id
                );
                setProductType(tempProductType);
              },
              errorCallback: () => { },
            })
          );
          const postData = {
            productTypeId: res?.data?.productType?._id,
          };
          dispatch(
            getCategoryList({
              params: postData,
              callback: (response: any) => {
                setCategoryList(response);
                let tempCategory = response?.find(
                  (item: any) => res?.data?.categoryId?._id === item?._id
                );
                setCategory(tempCategory);
              },
              errorCallback: (error: any) => { },
            })
          );
          const postdata = {
            productTypeId: res?.data?.productType?._id,
            categoryId: res?.data?.categoryId?._id,
          };
          dispatch(
            getProductList({
              params: postdata,
              callback: (req: any) => {
                setProductList(req);
                let tempProduct = req?.find(
                  (item: any) => value?.productId?._id === item?._id
                );
                setProduct(tempProduct);
              },
              errorCallback: (error: any) => { },
            })
          );
          setStartDate(
            moment
              .utc(res?.data?.startDate)
              // .utcOffset(330)
              .format("YYYY-MM-DD HH:mm:ss")
          );
          setEndDate(
            moment
              .utc(res?.data?.endDate)
              // .utcOffset(330)
              .format("YYYY-MM-DD HH:mm:ss")
          );
          setCategory(res?.data?.categoryId);
          setProduct(res?.data?.productId);
        },
        errorCallback: (error: any) => { },
      })
    );
  };

  const handleDelete = (value: any) => {
    setisEditMode(false);
    dispatch(
      deleteCouponCode({
        id: value._id,
        callback: (res: any) => {
          getdata();
        },
        errorCallback: () => { },
      })
    );
  };

  const validations = () => {
    let valid = false;
    if (couponType?._id === 1) {
      if (couponName === "" || startDate === "" || couponType === "" || endDate === "") {
        valid = true;
      }
    }
    if (couponType?._id === 2) {
      if (couponName === "" || startDate === "" || couponType === "" || endDate === "" || productType === "") {
        valid = true;
      }
    }
    if (couponType?._id === 3) {
      if (couponName === "" || startDate === "" || couponType === "" || endDate === "" || productType === "" || category === "") {
        valid = true;
      }
    }
    if (couponType?._id === 4) {
      if (couponName === "" || startDate === "" || couponType === "" || endDate === "" || productType === "" || category === "" || product === "") {
        valid = true;
      }
    }
    return valid;
  };
  const handleUpdate = (e: any) => {
    e.preventDefault();
    const postData: any = {};
    if (couponData?.name !== couponName) {
      postData["name"] = couponName;
    }
    if (couponData?.discPer !== discPer) {
      postData["discPer"] = discPer;
    }
    if (
      moment
        .utc(couponData?.startDate)
        .utcOffset(330)
        .format("YYYY-MM-DD HH:mm:ss") !== startDate
    ) {
      postData["startDate"] = startDate;
    }
    if (
      moment
        .utc(couponData?.endDate)
        .utcOffset(330)
        .format("YYYY-MM-DD HH:mm:ss") !== endDate
    ) {
      postData["endDate"] = endDate;
    }
    if (couponData?.productType?.productType !== productType?.productType) {
      postData["productType"] = productType?.productType;
    }
    if (couponData?.category?._id !== category?._id) {
      postData["categoryId"] = category?._id;
    }
    if (couponData?.product?._id !== product?._id) {
      postData["productId"] = product?._id;
    }
    if (couponData?.CouponType?.name !== couponType?.name) {
      postData["couponType"] = couponType?.name;
    }

    dispatch(
      updateCouponCode({
        id: couponId,
        params: postData,
        callback: (res: any) => {
          if (res?.status === 200) {
            dispatch(showSnackbar({ message: res?.msg, type: res?.type }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
            setisEditMode(false);
            setCategoryList([]);
            setProductTypeList([]);
            setProductType("");
            setCategory("");
            setCouponCodeList([]);
            setCouponName("");
            setCouponType("");
            setDiscPer("");
            setProductList([]);
            setProduct("");
            setCouponId("");
            setCouponData("");
            setStartDate(moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss"));
            setEndDate(moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss"));
            getdata();
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };

  const renderTable = () => {
    return (
      <div className="mt-4">
        <AdminTable
          tableData={couponCodeList ? couponCodeList : []}
          pagename={"couponCode"}
          tableHead={[
            "S.N",
            "Coupon Name",
            "Start Date",
            "End Date",
            "Coupon Type",
            "Discount Percentage",
            "Action",
          ]}
          handleEdit={(value: any) => handleEdit(value)}
          handleDelete={(value: any) => handleDelete(value)}
          edit={true}
        />
      </div>
    );
  };
  const renderEditMode = () => {
    return (
      <div className="">
        <form onSubmit={handleUpdate}>
          <div className="row ">
            <div className="col-md-4 mb-3">
              <LabelInput labelName={"Coupon Name"} isRequired />
              <InputField
                placeholder={"Enter Coupon Name"}
                setInputText={(value: any) => onchangeCouponCode(value)}
                value={couponName}
                disabled={true}
              />
            </div>
            <div className="col-md-4 mb-3">
              <LabelInput labelName={"Coupon Type"} isRequired />
              <DropdownWithClear
                labelName={"Select Coupon Type"}
                setInputText={(value: any) => onchangeCouponType(value)}
                options={couponTypeList}
                value={couponType}
                defaultValue={couponType?._id}
              />
            </div>
            {couponType?._id === 4 ? (
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Discount Percentage"} isRequired />
                <InputField
                  placeholder={"Enter Discount Percentage"}
                  setInputText={(value: any) => onchangeDiscPer(value)}
                  value={discPer}
                />
              </div>
            ) : null}
            <div className="col-md-4 mb-3">
              <LabelInput labelName={"Start Date"} isRequired />
              <DateTimePicker
                setInputText={(value: any) => {
                  onchangeStartDate(value);
                }}
                value={startDate}
              />
            </div>
            <div className="col-md-4 mb-3">
              <LabelInput labelName={"End Date"} isRequired />
              <DateTimePicker
                setInputText={(value: any) => {
                  onchangeEndDate(value);
                }}
                value={endDate}
              />
            </div>
            {(couponType?._id !== 1 || couponType?._id === 4) && (
              <>
                <div className="col-md-4 mb-3">
                  <LabelInput labelName={"Product Type"} isRequired />
                  <DropdownWithClear
                    labelName={"Select Product Type"}
                    setInputText={(value: any) => onchangeProductType(value)}
                    options={productTypeList}
                    value={productType}
                    disabled={couponType?._id === 1}
                  />
                </div>
                {couponType?._id !== 2 && (
                  <>
                    <div className="col-md-4 mb-3">
                      <LabelInput labelName={"Category"} isRequired />
                      <DropdownWithClear
                        labelName={"Select Product category "}
                        setInputText={(value: any) => onchangeCategory(value)}
                        options={categoryList}
                        value={category}
                        disabled={couponType?._id === 1 || couponType?._id === 2}
                      />
                    </div>
                    {couponType?._id !== 3 && (
                      <div className="col-md-4 mb-3">
                        <LabelInput labelName={"Product List"} isRequired />
                        <DropdownWithClear
                          labelName={"Select Product List "}
                          setInputText={(value: any) => onchangeProduct(value)}
                          options={productList}
                          value={product}
                          disabled={
                            couponType?._id === 1 ||
                            couponType?._id === 2 ||
                            couponType?._id === 3
                          }
                        />
                      </div>
                    )}
                  </>
                )}
              </>
            )}
            <div className="d-flex justify-content-center mt-3">
              <div className="col-2 pt-2">
                <Submitbtn name={"Submit"} disabled={validations()} />
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  };
  const handleGoBack = () => {
    setisEditMode(false);
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Edit / Delete Coupon Code"}
          breadCrumb={""}
          isEditMode={isEditMode}
          setisEditMode={setisEditMode}
          cancelEdit={() => handleGoBack()}
        />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius">
          {isEditMode ? renderEditMode() : renderTable()}
        </div>
      </div>
    </div>
  );
};

export default EditDeleteCouponCode;
